import SparkMD5 from 'spark-md5';
import api from '../api/common';
import store from '@/vuex/store';

/**
 * 大文件
 * @param file 文件
 * @param size 大小
 * */
const section = (file, size = 1) => {
  const CHUNK_SIZE = size * 1024 * 1024;
  const blob = new Blob([file.raw], { type: file.raw.type });
  const fileChunkList = [];
  let cur = 0;
  while (cur < blob.size) {
    fileChunkList.push({
      file: blob.slice(cur, cur + CHUNK_SIZE)
    });
    cur += CHUNK_SIZE; // CHUNK_SIZE为分片的大小
  }
  return fileChunkList;
};
/**
 * @param fileChunks 数组
 * @param size 大小
 * */
const calculateHash = async (fileChunks, size = 1) => {
  return new Promise(resolve => {
    const CHUNK_SIZE = size * 1024 * 1024;
    const spark = new SparkMD5.ArrayBuffer();
    const chunks = [];
    fileChunks.forEach((chunk, index) => {
      if (index === 0 || index === fileChunks.length - 1) {
        chunks.push(chunk.file);
      } else {
        chunks.push(chunk.file.slice(0, 2));
        chunks.push(chunk.file.slice(CHUNK_SIZE / 2, CHUNK_SIZE / 2 + 2));
        chunks.push(chunk.file.slice(CHUNK_SIZE - 2, CHUNK_SIZE));
      }
    });
    const reader = new FileReader();
    reader.readAsArrayBuffer(new Blob(chunks));
    reader.onload = e => {
      if (e) spark.append(e.target.result);
      resolve(spark.end());
    };
  });
};
/**
 * 切片上传到服务器
 * @param fileChunks 切片数组
 * @param fileHash 切片文件hash
 * @param fileName 总文件名
 * */
const uploadChunks = async (fileChunks = [], fileHash, fileName) => {

  return new Promise((resolve) => {
    const data = fileChunks.map(({ file }, index) => ({
      fileHash: fileHash,
      index,
      chunkHash: `${fileHash}-${index}`,
      chunk: file,
      size: file.size
    }));
    if (data.length > 0) {
      if (store.state.progress == -1) {
        store.state.progress = (1 / data.length).toFixed(2) * 100;
      }
    } else {
      store.state.progress = 99;
    }

    let remainIndex = null; //  服务器所需切片索引数组
    const params = {
      fileName,
      fileHash,
      totalPieces: data.length
    };
    api.checkChunkUpload(params).then(async res => {
      if (res.data.allCompleted) {
        store.state.progress = -1;
        resolve({
          ...res,
        });
        return;
      }
      if (!res.data.remainIndex) {
        setTimeout(() => {
          uploadChunks(fileChunks, fileHash, fileName).then(res => {
            resolve(res);
          });
        }, 5000);
        return;
      }

      remainIndex = res.data.remainIndex;

      const formDatas = data.filter((chunk, index) => {
        // 过滤服务器上已经有的切片
        if (remainIndex) {
          return remainIndex.includes(index);
        } else return true;
      });
      let formArr = formDatas.map(({ chunk, chunkHash, index }) => {
        const formData = new FormData();
        // 切片文件
        formData.append('chunk', chunk);
        // 切片文件索引
        formData.append('index', index.toString());
        // 切片文件hash
        formData.append('chunkHash', chunkHash);
        // 大文件的文件名
        formData.append('fileName', fileName);
        // 大文件hash
        formData.append('fileHash', fileHash);
        // 切片总数
        formData.append('totalPieces', data.length.toString());
        return formData;
      });
      let index = 0;
      const max = 1; // 并发请求数量
      const taskPool = []; // 请求队列
      while (index < formArr.length) {
        const params = formArr[index];
        const task = api.chunkUpload(params);
        task.then(res => {
          taskPool.splice(taskPool.findIndex(item => item === task));
          store.state.progress = res.data.rate * 100;
          if (res.data.allCompleted) {
            resolve({
              ...res,
              countLength: data.length.toString()
            });
            store.state.progress = -1;
            formArr.length = 0;
            return;
          }
          // 当传输切片中的时候，在check已经把数据上传完毕，则后续不需要再次上传，直接调用check获取结果
          if (!res.data.remainIndex) {
            setTimeout(() => {
              uploadChunks(fileChunks, fileHash, fileName).then(res => {
                resolve(res);
              });
            }, 5000);
            return;
          }
          // 当切片循环完毕，直接调用check获取结果
          if (index === formArr.length - 1) {
            setTimeout(() => {
              uploadChunks(fileChunks, fileHash, fileName).then(res => {
                resolve(res);
              });
            }, 5000);
          }
          // if (res.data.allCompleted) resolve(res);˝
        }).catch(_ => {
          store.state.progress = -1;
          formArr.length = 0;
          resolve(false);
        });
        taskPool.push(task);
        if (taskPool.length === max) {
          // 当请求队列中的请求数达到最大并行请求数的时候，得等之前的请求完成再循环下一个
          await Promise.race(taskPool);
        }
        index++;
      }
      await Promise.all(taskPool);
    });
  });
};
export {
  section,
  calculateHash,
  uploadChunks
};



// WEBPACK FOOTER //
// ./src/utils/fileSection.js